<template>
  <div class="partial">
    <wallet-connect :cartData="cartData" :qrDataProps="qrData" />
  </div>

</template>
<script>

export default {
  name: "PartialPayment",
  props: {
    qrData: Object,
    cartData: Object
  },
  data() {
    return {
      isLinkExpired: false,
      isTransactionExpired: false,
    };
  },
};
</script>
<style lang="scss">
.partial {
  padding: 60px 0;
}
</style>
